import authVuexModuel from './';

export default function(store, namespace) {
    store.registerModule(namespace, authVuexModuel);
}



// WEBPACK FOOTER //
// ./resources/assets/js/auth/lib/state/register-vuex-module.js